import { useCallback, useState } from 'react';
import { ensureAnonymousAuth, getMediaTypeForMedia, uploadFileDirect } from '@hs/shared';
import { trpc } from '@/lib/trpc';

const CLOUDBASE_ENV_ID = 'his-1g5d6vlz6368064f';

/**
 * 将本地图片上传至云存储并登记为媒体资源，返回可持久化的 HTTPS URL。
 */
export function useUploadMediaImage() {
  const [isUploading, setIsUploading] = useState(false);
  const authorizeUploadMutation = trpc.assets.authorizeUpload.useMutation();
  const createMediaMutation = trpc.assets.create.useMutation();

  const uploadImage = useCallback(
    async (file: File): Promise<string> => {
      setIsUploading(true);
      try {
        const { objectKey } = await authorizeUploadMutation.mutateAsync({
          fileName: file.name,
          mimeType: file.type || 'application/octet-stream',
          fileSize: file.size,
        });
        await ensureAnonymousAuth(CLOUDBASE_ENV_ID);
        const result = await uploadFileDirect({ envId: CLOUDBASE_ENV_ID }, file, { path: objectKey });
        const media = await createMediaMutation.mutateAsync({
          name: file.name,
          fileId: result.fileId,
          fileSize: file.size,
          mimeType: file.type || 'application/octet-stream',
          type: getMediaTypeForMedia(file.type, file.name),
          isOwner: true,
          /** 写入画布 JSON 需长期有效，与头像上传一致 */
          urlType: 'permanent',
        });
        const url = (media as { url?: string | null }).url;
        if (!url) throw new Error('上传成功但未返回地址');
        return url;
      } finally {
        setIsUploading(false);
      }
    },
    [authorizeUploadMutation, createMediaMutation],
  );

  return { uploadImage, isUploading };
}
